import { render, staticRenderFns } from "./Anotaciones.vue?vue&type=template&id=077e9315&"
import script from "./Anotaciones.vue?vue&type=script&lang=js&"
export * from "./Anotaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports